import { render, staticRenderFns } from "./IconPT.vue?vue&type=template&id=5ae8324a&"
import script from "./IconPT.vue?vue&type=script&lang=js&"
export * from "./IconPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports